import { useRef } from 'react'
import { ChartContainer } from '../../../../../../common/chart/chartContainer'
import Bar from '../../../../../../common/chart/chartContainer/Bar'
import { Legend } from '../../../../../../common/chart/legend'
import { Element } from '../../../../../../common/html/element'
import { SCREEN } from '../../../../../../common/selectCurrencyUnit/constant'
import { useFormatCurrency } from '../../../../../../common/selectCurrencyUnit/useFormatCurrency'
import { getUnique } from '../../../../../../helpers/common'
import { formatByTheme } from '../../../../../../helpers/theme'
import { isInValidValue } from '../../../../../../helpers/value'
import classes from '../../../index.module.scss'

const Chart = ({
  data,
  isCheckbox,
  checkboxs,
  checked,
  setChecked,
  isDynamicReport,
}) => {
  const chartId = useRef(getUnique())

  const { formatedUnit, formatValueWithUnit, decimalLength } =
    useFormatCurrency(SCREEN.FINANCIAL_ANALYSIS)

  const handleSetChecked = (checked) => {
    if (checkboxs.some((checkbox) => checked.includes(checkbox.value))) {
      setChecked(checked)
    }
  }

  const barChecked = checkboxs.filter((item) => checked.includes(item.value))
  const groupStackBarKeys = barChecked.map((bar) => bar.value)

  return (
    <div className="h100 dFlex">
      <div className="flexColumn w60 h100">
        <ChartContainer
          chartId={chartId.current}
          margin={{
            top: 0,
            left: isDynamicReport ? 16 : 0,
            bottom: 0,
            right: 30,
          }}
          data={data}
          width="100%"
          height="100%"
          layout="vertical"
          cartesianGrid={{
            vertical: true,
            horizontal: false,
            stroke: formatByTheme('#E5E5E8'),
          }}
          yAxis={[
            {
              dataKey: 'year',
              yAxisId: 'left',
              type: 'category',
            },
          ]}
          xAxis={[
            {
              type: 'number',
              dataKeys: barChecked.map((item) => item.value),
              isStackedBar: true,
              axisLine: false,
              tick: { fill: formatByTheme('#9C9C9C') },
              decimalLength,
            },
          ]}
          tooltip={{
            schema: {
              content: barChecked.map((item) => ({
                dataKey: item.value,
                label: item.title,
                formatValue: (value) => formatValueWithUnit({ value }),
              })),
            },
          }}
        >
          {barChecked.map((item, barIndex) => (
            <Bar
              key={item.value}
              yAxisId="left"
              dataKey={item.value}
              stackId="bar"
              barSize={25}
              fill={item.color}
              showLabelEmpty={({ index }) =>
                barIndex === 0 &&
                groupStackBarKeys.every((dataKey) =>
                  isInValidValue(data[index][dataKey]),
                )
              }
            />
          ))}
        </ChartContainer>
      </div>
      <div className="h100 w40 flexColumn">
        <div className="h100 w100 pl1 pb1 dFlex alignItemsCenter">
          <Legend
            chartId={chartId.current}
            items={checkboxs.map((item) => ({
              title: item.title,
              value: item.value,
              dataKey: item.value,
              color: item.color,
              isCheckbox: isCheckbox,
              listCheckBox: checked,
              setListCheckBox: handleSetChecked,
              isI18n: false,
              isDynamicReport: isDynamicReport,
            }))}
            className="flexColumn"
          />
        </div>
        <Element className={classes.pb2} style={{ color: '#9C9C9C' }}>
          {formatedUnit}
        </Element>
      </div>
    </div>
  )
}

export default Chart
